/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class GrouptargetsDialog extends NoboxEntityDialog<GrouptargetsRow, any> {
        protected getFormKey() { return GrouptargetsForm.formKey; }
        protected getIdProperty() { return GrouptargetsRow.idProperty; }
        protected getLocalTextPrefix() { return GrouptargetsRow.localTextPrefix; }
        protected getNameProperty() { return GrouptargetsRow.nameProperty; }
        protected getService() { return GrouptargetsService.baseUrl; }
        protected getDeletePermission() { return GrouptargetsRow.deletePermission; }
        protected getInsertPermission() { return GrouptargetsRow.insertPermission; }
        protected getUpdatePermission() { return GrouptargetsRow.updatePermission; }

        protected form = new GrouptargetsForm(this.idPrefix);
        public grid: any;
        constructor() {
            super();
            this.element.children("div.panel-titlebar").css("justify-content", "space-between");
            this.element.children("div.panel-titlebar").append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="https://crm.nobox.ai/knowledge-base/article/setting">
                    <div class="tool-button icon-tool-button" title="Help">
                        <div class="button-outer">
                            <span class="button-inner green">
                                <i class="fa fa-question-circle text-blue"></i>
                            </span>
                        </div>
                    </div>
                </a>`);
        }
        getCookie(currency) {
            const value = ` ; ${document.cookie}`;
            const parts = value.split(`; ${currency}=`);

            if (parts[1] == undefined) {
                if (currency == "currency") {
                    return "Rp";
                }
            } else {
                return parts[1].split(';').shift();
            }

        };


        protected updateInterface() {
            super.updateInterface();

            var $this = this;
            if ($this.grid) {
                Serenity.EditorUtils.setValue($this.form.GrpId, $this.grid)
            }
            if (Q.isEmptyOrNull(this.get_entity().Currencies)) {
                this.form.Currencies.set_value(($.cookie('currencies') == undefined ? "Rp" : $.cookie('currencies')))
            }
            if (Q.isEmptyOrNull(this.get_entity().Currencies)) {
                this.form.Currencies.value = $.cookie('currencies') == undefined ? "Rp" : $.cookie('currencies');
            }
            if (Q.isEmptyOrNull(this.get_entity().Cry)) {
                this.form.Cry.set_value(($.cookie('currencies') == undefined ? "Rp" : $.cookie('currencies')))
            }

            this.dialogTitle = "Group Annual Target";
        }
        protected getToolbarButtons() {
            var btn = super.getToolbarButtons();
            btn[3].visible = false;
            btn[4].visible = false;
            return btn;
        }
    }
}